export default __webpack_public_path__ + "static/media/webservice.4aaa080e.png";